@for (field of normalizedFields(); track field) {
    <div class="modal-panel modal-panel-input">
        @if (field.label) {
            <div class="number-field-label" [attr.disabled]="'disabled'">{{ field.label }}</div>
        }
        <input
            type="number"
            [(ngModel)]="datasource()[field.name]"
            [ngModelOptions]="{ standalone: true }"
            [required]="required()"
            [attr.min]="min()"
            [attr.max]="max()"
        />
        @if (!!pattern()) {
            <input
                hidden
                type="number"
                [(ngModel)]="datasource()[field.name]"
                [ngModelOptions]="{ standalone: true }"
                [attr.pattern]="pattern()"
            />
        }
    </div>
}
